module.exports = __webpack_public_path__ + "static/img/2.adf5f7b9.png";